import React from 'react';
import { Box } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import HeroSection from './HeroSection';
import InstructionsSection from './InstructionsSection';

const LandingPage = () => {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (googleToken) => {
    try {
      await loginWithGoogle(googleToken);
      navigate('/dashboard');
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  const handleError = (error) => {
    console.error('Google OAuth error:', error);
  };

  return (
    <Box>
      <HeroSection onLogin={handleLogin} onError={handleError} />
      <InstructionsSection />
    </Box>
  );
};

export default LandingPage;